import React, { Fragment, useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QR from 'qrcode.react';
import moment from 'moment';
import { Modal, Form, Radio, Input, Button, message, Icon, Breadcrumb, Select, Spin, Tooltip } from 'antd';
import { RightOutlined, ExclamationCircleFilled, CheckOutlined, InfoCircleFilled, CheckCircleFilled, MinusCircleFilled } from '@ant-design/icons';
import _get from 'lodash/get';
// import Timer from '../../components/Timer';
import { requestStoreInvoice, postContact, putExchange, getExchange, postInvoice, getActivation, getActivate, getDashDiscount, getPluginData, } from '../../common/fetch';
import {
    FIRE_BALL,
    XHT_ICON_LIGHT,
    CURRENT_PLAN_CLOUD_ICON,
    EXCHANGE_CARD_ICON,
    EMAIL_PENDING_ICON,
    VERIFICATION_TICK_ICON,
    KYC_PLUGIN_ICON,
    VERSION_TICK,
    EURO_FLAG,
    DIY_BOOST_ICON,
    DIY_ICON,
    // BITHOLLA_PAYMENT_BRAND,
    // CLOUD_OUTLINE,
    // BANK_ICON,
    // KOREA_FLAG
} from '../../config/media';
import ConfigurePlan from '../ConfigurePlan/index';
import Wrapper from './style';
import ConfigWrapper from '../ConfigurePlan/style';
import EnterpriseForm from '../EnterpriseForm';
import { getCookie } from '../../common/utils';
import FiatConfirmation from './FiatConfirmation';
import PluginSubscription from './PluginSubscription';
import BillingActions from '../../actions/BillingAction';

const { Item } = Breadcrumb;
const { Option } = Select;

const ModalContent = Form.create({ name: 'EnterPriseForm' })(EnterpriseForm);

const payOptions = [
    { key: 'pay', value: 'Pay from wallet' },
    { key: 'transfer', value: 'Transfer crypto' }
];

const PaymentModal = ({
    balance = {},
    isOpen,
    isEdit = false,
    getInvoice,
    invoiceData = {},
    history = {},
    onOk,
    onCancel,
    exchange = {},
    type,
    isMonthly,
    handleSelect,
    handleToggle,
    contentType,
    priceData,
    onCancelPlanModal,
    updatePlanType,
    hideBreadcrumb,
    actions,
    isAutomatedKYC,
    tabParams,
    updateTabParams,
    isPendingPay,
    isBilling,
    pluginData,
    isPay,
    isLoading,
    handleLoading,
    discountedPercentage,
    setDiscountedPercentage,
    updatedPlugin,
    setUpdatedPlugin,
    selectedpluginDetail,
    setSelectedpluginDetail
}) => {
    const [paymentType, setPayType] = useState('paypal');
    const [nextType, setNextType] = useState('price');
    const [currency, setCurrency] = useState('usdt');
    const [invoice, setInvoice] = useState({});
    const [currencyData, setCurrencyAddress] = useState({});
    const [loading, setLoading] = useState(false);
    const [addressRef, setAddressRef] = useState(null);
    const [cryptoPayType, setCryptoPay] = useState('transfer');
    const [isHideBreadcrumb, setHideBreadcrumb] = useState(false);
    const [isFiatFormCompleted, setFiatCompleted] = useState(false);
    const [isExchangeDetails, setExchangeDetails] = useState(false);
    const [paymentOptions, setOptions] = useState([]);
    const [bank_identifier, setBankIdentifier] = useState('european_bank');
    const [is_active, setActive] = useState(false)
    const [discountValue, setDiscountValue] = useState('');
    const [discountData, setDiscountData] = useState(invoice);
    const [isDisCount, setIsDiscount] = useState({ isError: false, isSuccess: false })
    const [isErrorMsg, setIsErrorMsg] = useState({ status: false, errMsg: 'Payment method is not accepted' });

    const imgIndex = ((exchange.id || 0) % 6) + 1;
    const originalPrice = selectedpluginDetail && selectedpluginDetail.map((val) => val.price);
    const discountedPrice = invoice && invoice.amount;

    const calculateDiscountPercentage = (originalPrice, discountedPrice) => originalPrice && originalPrice[0] ? ((originalPrice[0] - discountedPrice) / originalPrice[0]) * 100 : 0;

    const discountPercentage = calculateDiscountPercentage(originalPrice, discountedPrice);

    const isVoucher = useMemo(() => {
        return invoice && invoice.amount === (selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].price)
    }, [invoice, selectedpluginDetail])

    useEffect(() => {
        const getPlugins = async () => {
            const res = await getPluginData();
            setUpdatedPlugin(res.data.data);
        }
        getPlugins();
    }, [setUpdatedPlugin]);

    useEffect(() => {
        setDiscountedPercentage(discountPercentage)
    }, [setDiscountedPercentage, discountPercentage]);


    const isVoucherAppliedPlugin = useMemo(() => {
        if (invoice && invoice.item !== 'plugin') {
            return invoice && (invoice.amount === discountData.amount)
        }
        return updatedPlugin && updatedPlugin.some((ele) => {
            return ((ele.price === discountData.amount) || (ele.price === invoice.amount))
        })
    }, [invoice, discountData, updatedPlugin]);

    const getActiveStatus = async () => {
        try {
            const activation = await getActivation('automatic-kyc');
            setActive(_get(activation, 'data.is_active'));
            return _get(activation, 'data.is_active');
        } catch (err) {
            setActive(false);
            return false;
        }
    };

    const handleInvoice = useCallback(async (name) => {
        try {
            const body = [
                {
                    name,
                    type: "addon"
                },
            ];
            const activation = await getActiveStatus();
            if (!activation) {
                body.push({
                    name: "automatic-kyc",
                    type: "plugin"
                });
            }
            const res = await postInvoice(body);
            setInvoice(res.data);
            getInvoice();
        } catch (error) {
            message.error(error.data.message);
        }
    }, [getInvoice]);

    useEffect(() => {
        setInvoice(invoiceData);
        setDiscountData(invoiceData);
        setPayType('cryptoCurrency');
        if (invoiceData) {
            const { method, amount } = invoiceData;
            if (['usdt', 'btc', 'eth', 'xht'].includes(method)) {
                if (amount > 15000) {
                    setCurrency('usdt');
                } else {
                    setCurrency(method);
                }
                setPayType('cryptoCurrency');
            } else if (type === 'basic') {
                setPayType('cryptoCurrency');
            }
        }
    }, [invoiceData, type]);
    useEffect(() => {
        setNextType(contentType);
        setHideBreadcrumb(hideBreadcrumb);
    }, [contentType, hideBreadcrumb])
    useEffect(() => {
        if (type !== "fiat") {
            setFiatCompleted(false);
        }
    }, [type])

    useEffect(() => {
        if (tabParams
            && tabParams.currentTab
            && tabParams.type
            && tabParams.invoiceData) {
            setNextType(tabParams.currentTab);
            setPayType(tabParams.type);
            handleInvoice(tabParams.invoiceData);
        }
    }, [tabParams, handleInvoice]);

    useEffect(() => {
        const balanceAvailable = balance[`${currency.toLowerCase()}_available`] || 0;
        if (balanceAvailable && balanceAvailable >= currencyData.amount) {
            setOptions(payOptions);
        } else {
            const optionData = payOptions.filter(data => data.key !== 'pay');
            setOptions(optionData);
        }
    }, [balance, currency, currencyData]);

    const radioStyle = {
        display: 'flex',
        // alignItems: 'center',
        // height: '10px',
        lineHeight: '1',
        padding: '10px 0',
        margin: 0,
        paddingLeft: '1px',
        whiteSpace: 'normal',
        letterSpacing: '-0.15px',
    };
    const handleCopy = (e) => {
        const copyText = e.input;
        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/

        /* Copy the text inside the text field */
        document.execCommand('copy');
        message.success('Copied!');
    };

    const handleCryptoPay = (payType) => {
        setCryptoPay(payType);
    };

    const handleBreadCrumb = (key) => {
        switch (key) {
            case 'price':
                setNextType('price')
                setExchangeDetails(false)
                break;
            case 'payment':
                setNextType('payment')
                // setBankVisible(false)
                setExchangeDetails(false)
                break;
            case 'cryptoCurrency':
                setNextType('cryptoCurrency')
                setExchangeDetails(false)
                break;
            default:
                break;
        }
    }
    const renderBreadCrumb = () => {
        return (
            <div className="steps-wrapper">
                {!isHideBreadcrumb
                    ?
                    <Breadcrumb separator={<RightOutlined />}>
                        {isEdit || isAutomatedKYC
                            ? null
                            : <Item>
                                <span
                                    className={
                                        nextType === 'price'
                                            ? 'breadcrumb-item breadcrumb-item-active'
                                            : 'breadcrumb-item'
                                    }
                                    onClick={() => handleBreadCrumb('price')}
                                >
                                    Item
                                </span>
                            </Item>
                        }
                        <Item>
                            <span
                                className={
                                    nextType === 'payment' || nextType === "enterPrise" || (isAutomatedKYC && nextType === 'payment')
                                        ? 'breadcrumb-item breadcrumb-item-active'
                                        : (nextType !== 'price'
                                            ? 'breadcrumb-item'
                                            : ''
                                        )
                                }
                                onClick={() => {
                                    if (nextType !== 'price' && nextType !== 'payment') {
                                        handleBreadCrumb('payment')
                                    }
                                }}
                            >
                                Method
                            </span>
                        </Item>
                        {nextType === 'cryptoCurrency' || nextType === 'cryptoPayment'
                            ? <Item>
                                <span
                                    className={
                                        nextType === 'cryptoCurrency'
                                            ? 'breadcrumb-item breadcrumb-item-active'
                                            : 'breadcrumb-item'
                                    }
                                    onClick={() => {
                                        if (nextType !== 'cryptoCurrency') {
                                            handleBreadCrumb('cryptoCurrency')
                                        }
                                    }}
                                >
                                    Crypto
                                </span>
                            </Item>
                            : null
                        }
                        <Item>
                            <span
                                className={
                                    nextType === 'bank' || nextType === 'cryptoPayment'
                                        ? 'breadcrumb-item breadcrumb-item-active'
                                        : ''
                                }
                            >
                                Payment
                            </span>
                        </Item>
                    </Breadcrumb>
                    : null
                }
            </div >
        );
    }

    const handleViewPlan = () => {
        setNextType("price");
        setHideBreadcrumb(false);
    }

    const renderPrice = () => {
        let PriceValue = `${_get(discountData, 'currency', '').toUpperCase()} ${_get(discountData, 'amount', '')}`;
        if (invoice.method !== 'paypal' &&
            invoice.method !== 'bank' &&
            invoice.method !== 'stripe' &&
            invoice.meta &&
            invoice.meta.amount
        ) {
            PriceValue = `${invoice.meta.currency.toUpperCase()} ${invoice.meta.amount}`;
        }
        if (isEdit || isAutomatedKYC) {
            return (
                <Fragment>
                    <div className="sub-title">Payment:</div>{' '}
                    <div>{PriceValue}</div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <div className="sub-title">{isMonthly ? 'Monthly payment:' : 'Yearly payment:'}</div>{' '}
                    <div>{PriceValue}</div>
                </Fragment>
            );
        }
    };

    const renderFooterInfo = () => {
        const exchangePlans = ['basic', 'crypto', 'fiat'];
        if (!exchangePlans.includes(exchange.plan)) {
            if (type === 'boost' && invoiceData.item === 'boost') {
                return (
                    <div>
                        <div className="sub-title billing-package-text">Boost</div>
                        <span className="bodyContentSmall">HollaEx Yearly Boost</span>
                    </div>
                )
            } else {
                return (
                    <div>
                        <div className="sub-title billing-package-text">{invoice.item}</div>
                        <span className="bodyContentSmall">{invoice.description}</span>
                    </div>
                )
            }
        } else if (isAutomatedKYC && !is_active) {
            return (
                <div>
                    <div className="sub-title billing-package-text">Automated KYC</div>
                    <span className="bodyContentSmall">First time activation and {_get(invoice, 'meta.addon.count', '')} user verifications</span>
                </div>
            )
        } else if (is_active) {
            return (
                <div>
                    <div className="sub-title billing-package-text">Automated KYC</div>
                    <span className="bodyContentSmall">Charge {_get(invoice, 'meta.addon.count', '')} user verifications</span>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="sub-title billing-package-text">{invoice.item}</div>
                    <div className="bodyContentSmall text-center">{invoice.description}</div>
                </div>
            )
        }
    };

    const isCloud = () => {
        const exchangePlans = ['basic', 'crypto', 'fiat'];
        if (exchangePlans.includes(exchange.plan)) {
            return true;
        } else {
            return false;
        }
    };

    const renderFooterImage = () => {
        const exchangePlans = ['basic', 'crypto', 'fiat'];
        if (isAutomatedKYC) {
            return KYC_PLUGIN_ICON;
        } else if (exchange.plan === 'boost' && invoiceData.item === 'boost') {
            return DIY_BOOST_ICON;
        } else if (!exchangePlans.includes(exchange.plan) && invoiceData.item !== 'boost') {
            return DIY_ICON;
        } else {
            return CURRENT_PLAN_CLOUD_ICON;
        }
    };

    const renderFooter = () => {
        return (
            <div className="cloud-plan-wrapper">
                <div className="cloud-content">
                    <div className='plans-title-wrapper'>
                        <h3 className="bold">
                            {isBilling ? "" : isAutomatedKYC ? 'Selected item' : (isCloud() ? 'Selected cloud plan' : 'Selected DIY plan')}
                        </h3>
                        {(isDisCount.isSuccess || (!isVoucherAppliedPlugin && !isVoucher)) && <div className='display-discount'>
                            <h5 className='discount-percentage-label'>DISCOUNTED {discountedPercentage}%</h5>
                            <CheckCircleFilled className='checked-discount-icon' />
                        </div>}
                    </div>
                    {isBilling || invoiceData.item === 'plugin' || isAutomatedKYC ?
                        handleLoading
                            ? <Spin isLoading={true} />
                            : <PluginSubscription updatedPlugin={updatedPlugin} selectedpluginDetail={selectedpluginDetail} setSelectedpluginDetail={setSelectedpluginDetail} discountPrice={discountData} isPay={isPay} invoice={invoice} renderBtn={renderBtn} item={false} invoiceData={invoiceData} />
                        : handleLoading ? <Spin isLoading={true} />
                            : <div className="cloud-box-container d-flex">
                                <div className="content-align d-flex">
                                    <img
                                        src={renderFooterImage()}
                                        alt="cloud-icon"
                                        className="cloud-icon"
                                    />
                                    {renderFooterInfo()}
                                </div>
                                <div className="content-align d-flex seperator">
                                    <img
                                        src={EXCHANGE_CARD_ICON[imgIndex]}
                                        alt="Exchange-icon"
                                        className="exchange-icon"
                                    />
                                    <span className="bodyContentSmall">{exchange.display_name}</span>
                                </div>
                                <div className="content-align d-flex">
                                    {renderPrice()}
                                </div>
                            </div>
                    }
                </div>
                <div className="button-container">
                    {renderBtn()}
                </div>
            </div>
        )
    }

    const getExchangeData = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });
            actions(exchange);
        } catch (error) {
            console.error(error);
        }
    }

    const submitEnterprise = async (formProps) => {
        const data = {
            email: getCookie('email'),
            category: 'enterprise',
            subject: 'enterprise exchange',
            description: JSON.stringify(formProps)
        };
        const body = {
            id: exchange.id,
            business_info: formProps
        };
        try {
            const res = await postContact(data);
            await putExchange(body);
            await getExchangeData();
            message.success(res.message);
            setNextType("fiat-application");
            setHideBreadcrumb(true);
        } catch (error) {
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error('Fail to message');
            }
        }
    };

    const onHandleAplly = () => {
        getDashDiscount({ "invoice_id": invoice.id, "code": discountValue })
            .then(async (res) => {
                setInvoice({ ...invoice, amount: res.data.amount });
                setDiscountedPercentage(res.data.discount);
                setDiscountData({ ...discountData, amount: res.data.amount, currency: res.data.currency });
                await requestStoreInvoice(invoice.id, { method: paymentType, amount: res.data.amount })
                    .then(() => {
                        setIsDiscount({ ...isDisCount, isError: false });
                    })
                    .catch((error) => {
                        setIsDiscount({ ...isDisCount, isSuccess: true });
                        setIsErrorMsg({ ...isErrorMsg, errMsg: error.data.message, status: true });
                        message.error(isErrorMsg.errMsg);
                    })
            })
            .catch(error => {
                setIsDiscount({ ...isDisCount, isError: true });
                setIsDiscount({ ...isDisCount, isSuccess: false });
                message.error(error && error.data && error.data.message ? error.data.message : isErrorMsg.errMsg);
            });
    }

    const renderContent = () => {
        const isMaxAmount = invoice && invoice.amount && (invoice.amount > 15000);
        switch (nextType) {
            case 'price':
                return (!isBilling ?
                    <ConfigWrapper>
                        <div className="steps-content-wrapper">
                            <div className="d-flex">
                                <div className="box-container">
                                    <div className="content-wrapper">
                                        <ConfigurePlan
                                            selectedType={type}
                                            priceData={priceData}
                                            exchange={exchange}
                                            isMonthly={isMonthly}
                                            planType={'ConfigurePlan'}
                                            handleSelect={handleSelect}
                                            handleToggle={handleToggle}
                                            handleClose={onCancelPlanModal}
                                            onCancel={onCancel}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isFiatFormCompleted
                            ? <div className="success-msg">You've already submitted a Fiat Ramp form.</div>
                            : null
                        }
                        {((!exchange.is_paid) || (exchange.is_paid && moment().isAfter(moment(exchange.expiry))))
                            ?
                            <div className="button-container">
                                {renderBtn()}
                            </div>
                            : null
                        }
                    </ConfigWrapper>
                    :
                    <PluginSubscription updatedPlugin={updatedPlugin} discountPrice={discountData} selectedpluginDetail={selectedpluginDetail} setSelectedpluginDetail={setSelectedpluginDetail} pluginData={pluginData} invoice={invoice} renderBtn={renderBtn} />
                );
            case 'payment':
                return (
                    <div>
                        <div className="steps-content-wrapper">
                            <Form>
                                <h3 className="bold">Select payment method</h3>
                                <Form.Item name="paymentType">
                                    <Radio.Group
                                        name="paymentType"
                                        onChange={(e) => {
                                            setPayType(e.target.value)
                                        }}
                                        value={paymentType}
                                    >
                                        <Radio style={radioStyle} value={'cryptoCurrency'}>
                                            <span>Cryptocurrency </span>
                                            <span className="danger"> (up to 5% off) </span>
                                            <span><img src={FIRE_BALL} className="fire-icon" alt="fire" /></span>
                                        </Radio>
                                        <Radio style={radioStyle} value={'stripe'} disabled={false}>
                                            Credit Card
                                        </Radio>
                                        <Radio style={radioStyle} value={'paypal'} disabled={true}>
                                            PayPal
                                        </Radio>
                                        <Radio style={radioStyle} value={'b'} disabled={true}>
                                            Bank Wire Transfer
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <div className={(isDisCount.isError
                                ) ? 'discount-wrapper incorrect-wrapper' : 'discount-wrapper'}>
                                    <div className='d-flex'>
                                        <h4 className='dicount-header'>Discount voucher <span className='dicount-sub-header'>(optional)</span></h4>
                                        <Tooltip overlayInnerStyle={{ width: '20px' }} placement='right' title='Input and apply voucher code to obtain discount on your purchase'><InfoCircleFilled className="custom-info-circle" /></Tooltip>
                                    </div>
                                    <div className='d-flex discount-field-wrapper'>
                                        <Input className={(isDisCount.isError && !isDisCount.isSuccess) ? 'incorrect-disabled-state' : isDisCount.isSuccess ? "disabled-state" : ''} value={discountValue} disabled={isDisCount.isSuccess} onChange={(e) => setDiscountValue(e.target.value)} placeholder='Input your discount code' />
                                        {(isDisCount.isSuccess || (!isVoucherAppliedPlugin && !isVoucher)) ?
                                            <div className='d-flex discount-applied-label'>
                                                <CheckOutlined className='discount-checked-icon' />
                                                <div className='success-discount-label'>Discount successfully applied!</div>
                                            </div> : !isDisCount.isSuccess ?
                                                <Button className='apply-btn' type='primary' onClick={() => onHandleAplly()} disabled={!discountValue ? true : false}>Apply</Button> : null}
                                    </div>
                                </div>
                                {(isDisCount.isError && !isDisCount.isSuccess) && <div className='d-flex'>
                                    <MinusCircleFilled className='error-filed-wrapper' />
                                    <p>Incorrect code. Please try again.</p>
                                </div>}
                            </Form>
                        </div>
                        {renderFooter()}
                    </div>
                );
            case 'paypal':
            case 'stripe':
                return (
                    <div></div>
                );
            case 'bank':
                return (
                    <div>
                        <div className='steps-content-wrapper'>
                            <Form>
                                <h3 className="bold">Select bank</h3>
                                <div className='input-field-wrapper'>
                                    <Radio.Group
                                        name='bank'
                                        onChange={(e) => setBankIdentifier(e.target.value)}
                                        value={bank_identifier}
                                    >
                                        {/*<Radio value='korean_bank'>
                                            <img className="flag-icon" alt="KOREA_FLAG" src={KOREA_FLAG} />
                                            Korean Bank
                                        </Radio>*/}
                                        <Radio value='european_bank'>
                                            <img className="flag-icon" alt="EURO_FLAG" src={EURO_FLAG} />
                                            European Bank
                                        </Radio>
                                    </Radio.Group>
                                </div>
                            </Form>
                        </div>
                        {/* <div className="steps-content-wrapper">
                            <h3 className="bold">Please wire money directly to one of the banks below:</h3>
                            <div className="bodyContent">Wire transfer can take 2-5 business days to arrive. Upon receiving your payment bitHolla will directly inform you via email.</div>
                            <div className="my-1">
                                <div className="d-flex">
                                    <div className="my-1">
                                        <img src={BANK_ICON} alt="bank" className="bank-icon" />
                                        <h3 className="bold">Korean Bank</h3>
                                        <div className="bodyContent">
                                            <span className="bold">Bank Name: </span>
                                            <span>Kookmin Bank</span>
                                        </div>
                                        <div className="bodyContent">
                                            <span className="bold">Account #: </span>
                                            <span>012537-04-007934</span>
                                        </div>
                                        <div className="bodyContent">
                                            <span className="bold">SWIFT Code: </span>
                                            <span>CZNBKRSE</span>
                                        </div>
                                        <div className="bodyContent">
                                            <span className="bold">Beneficiary: </span>
                                            <span>bitHolla Inc.</span>
                                        </div>
                                    </div>
                                    <div className="separator">
                                        <div className="line">Or</div>
                                    </div>
                                    <div className="my-1">
                                        <img src={BANK_ICON} alt="bank" className="bank-icon" />
                                        <h3 className="bold">European Bank</h3>
                                        <div className="bodyContent">
                                            <span className="bold">Bank Name: </span>
                                            <span>JSC TBC Bank</span>
                                        </div>
                                        <div className="bodyContent">
                                            <span className="bold">Ben's IBAN #: </span>
                                            <span>GE61TB7682145067800002</span>
                                        </div>
                                        <div className="bodyContent">
                                            <span className="bold">SWIFT Code: </span>
                                            <span>TBCBGE22</span>
                                        </div>
                                        <div className="bodyContent">
                                            <span className="bold">Beneficiary: </span>
                                            <span>Holla Technology LLC</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center bodyContentSmall">
                                    Some banks may require a 11 digit SWIFT code. You can fill the remaining character with XXX
                                </div>
                            </div>
                            <div>
                                <div className="amount link text-center">
                                    Send exactly: ${invoice.amount}*
                                </div>
                                <div className="text-center billing-package-text">{invoice.item}</div>
                            </div>
                            <div className="text-center bodyContentSmall">
                                {invoice.description}
                            </div>
                        </div> */}
                        {renderFooter()}
                    </div>
                );
            case 'cryptoCurrency':
                return (
                    <div>
                        <div className="steps-content-wrapper">
                            <Form>
                                <h3 className="bold">Pick Crypto</h3>
                                <div className="bodyContentSmall">Pick the cryptocurrency you want to use to pay.</div>
                                <Form.Item name="currency">
                                    <Radio.Group
                                        name="currency"
                                        onChange={(e) => {
                                            setCurrency(e.target.value);
                                        }}
                                        value={currency}
                                    >
                                        <Radio style={radioStyle} value={'usdt'}>
                                            USDT (TRC20)
                                        </Radio>
                                        <Radio style={radioStyle} value={'btc'}>
                                            <span>Bitcoin </span>
                                        </Radio>
                                        <Radio style={radioStyle} value={'eth'}>
                                            <span>Ethereum </span>
                                        </Radio>
                                        <Radio style={radioStyle} value={'xht'} disabled={isMaxAmount}>
                                            <span>XHT </span>
                                            <span className={isMaxAmount ? 'xht-disabled' : ''}>
                                                <span className="danger"> (5% discount) </span>
                                                <span><img src={FIRE_BALL} className="fire-icon" alt="fire" /></span>
                                            </span>
                                            <br />
                                            <div className="btn-divider" />
                                            <div className={isMaxAmount ? "bodyContentSmall xht-disabled" : "bodyContentSmall"}>
                                                Don't have XHT? Get XHT
                                                <a href='https://pro.hollaex.com/trade/xht-usdt' target='_blank' rel='noopener noreferrer'> here.</a>
                                            </div>
                                        </Radio>
                                        <Radio style={radioStyle} value={'trx'}>
                                            <span>TRON </span>
                                        </Radio>
                                        <Radio style={radioStyle} value={'xrp'}>
                                            <span>XRP </span>
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Form>
                        </div>
                        {renderFooter()}
                    </div>
                );
            case 'cryptoPayment':
                const balanceAvailable = balance[`${currency.toLowerCase()}_available`] || 0;
                return (
                    <div>
                        <div className="steps-content-wrapper">
                            {/* <h3 className="bold">Send crypto payment</h3> */}
                            <div className="d-flex align-center">
                                <div className="f-1">
                                    <div>
                                        <div className="bold my-mini">
                                            Select how to pay:
                                        </div>
                                        <div className="my-mini">
                                            <Select
                                                value='transfer'
                                                onChange={handleCryptoPay}
                                                placeholder="Select payment method"
                                            >
                                                {paymentOptions.map((item) => (
                                                    <Option value={item.key} key={item.key}>
                                                        {item.value}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                        {cryptoPayType === 'pay'
                                            ? <Fragment>
                                                <div className="my-mini">
                                                    <span className="bold">Selected crypto: </span>
                                                    <span>{currency ? currency.toUpperCase() : ''}</span>
                                                </div>
                                                <div className="my-mini">
                                                    <span className="bold">{`Your ${currency.toUpperCase()} balance: `}</span>
                                                    <span>{balanceAvailable}{' '}{currency.toUpperCase()}</span>
                                                </div>
                                                {!balanceAvailable || balanceAvailable < currencyData.amount
                                                    ? <div className="crypto-error">
                                                        <ExclamationCircleFilled />{' '}
                                                        Insufficient balance
                                                    </div>
                                                    : null
                                                }
                                                <div className="crypto-payment-divider"></div>
                                                <div>
                                                    <div className="crypto-required-amount">
                                                        Required amount: {' '}
                                                        {currencyData.amount} {currencyData.currency ? currencyData.currency.toUpperCase() : ''}
                                                    </div>
                                                    <div className="small-text">The required amount will be directly deducted from your account wallet balance. Please check the details before proceeding.</div>
                                                </div>
                                            </Fragment>
                                            : (cryptoPayType === 'transfer' ?
                                                <Fragment>
                                                    <div className="payment-details-wrapper">
                                                        <div className="my-mini">
                                                            <span className="bold">Selected crypto: </span>
                                                            <span>{currencyData.currency ? currencyData.currency.toUpperCase() : ''}</span>
                                                        </div>
                                                        <div className="my-mini">
                                                            <span className="bold">Required payment amount: </span>
                                                            <span>{currencyData.amount} {currencyData.currency ? currencyData.currency.toUpperCase() : ''}</span>
                                                        </div>
                                                        <div className="bodyContentSmall my-mini">
                                                            {currency === 'btc' && currency === 'eth' ? '*10% discount included' : ''}
                                                        </div>
                                                        {!isExchangeDetails ?
                                                            <Button onClick={() => setExchangeDetails(true)} type="primary">
                                                                Show payment address
                                                            </Button>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                    {isExchangeDetails ?
                                                        <div>
                                                            <div className="payment-details-wrapper mobile-qr-wrapper no-border d-flex align-center">
                                                                <div>
                                                                    <div className="bodyContentSmall my-mini">
                                                                        {currency === 'btc' && currency === 'eth' ? '*10% discount included' : ''}
                                                                    </div>
                                                                    <div className="currency-content">
                                                                        <span className="bold my-mini">Payment address:</span>
                                                                        <p>
                                                                            <Input
                                                                                ref={(el) => {
                                                                                    setAddressRef(el);
                                                                                }}
                                                                                value={currencyData.address}
                                                                                readOnly
                                                                                addonAfter={
                                                                                    <Icon
                                                                                        type="copy"
                                                                                        onClick={() => handleCopy(addressRef)}
                                                                                    />
                                                                                }
                                                                            />
                                                                        </p>
                                                                    </div>
                                                                    <div className="d-flex align-center my-1">
                                                                        {/* <Timer time={moment(currencyData.expiry).diff(moment(), 'seconds')} />
                                                                    <div className="timer-divider"></div>
                                                                    <div className="bodyContentSmall">
                                                                        You have 24 hours to pay to send your crypto payment. You can always come back and reselect paying with cryptocurrency and pay later.
                                                                    </div> */}
                                                                        <div className='warning-text d-flex'>
                                                                            <ExclamationCircleFilled className='warning-icon' />
                                                                            <div>
                                                                                <div>
                                                                                    Before sending your payment check and consider the
                                                                                </div>
                                                                                transaction fee and that the required amount is sufficient.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {cryptoPayType !== 'pay'
                                                                    ? <div className="qr-code-wrapper">
                                                                        <QR value={currencyData.address ? currencyData.address : ''} size={100} />
                                                                        <div className="bodyContentSmall">Scan this QR code</div>
                                                                    </div>
                                                                    : null
                                                                }
                                                            </div>
                                                            <div className="my-1">
                                                                After your payment has been received you will be sent an email with your payment details
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </Fragment>
                                                : null
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {renderFooter()}
                    </div>
                );
            case 'xhtPayment':
                return (
                    <div className="steps-content-wrapper text-center">
                        <h3 className="bold">Please review your crypto payment below:</h3>
                        <div className="bodyContentSmall">Please review your crypto payment below:</div>
                        <div><img src={XHT_ICON_LIGHT} className="bank-icon" alt="bank" /></div>
                        <div className="amount">Cost: {currencyData.amount} XHT*</div>
                        <div className="bold billing-package-text">{invoice.item}</div>
                        <div className="bodyContentSmall">{invoice.description}</div>
                        {renderFooter()}
                    </div>
                );
            case 'xhtInSufficient':
                return (
                    <div className="steps-content-wrapper text-center">
                        <h3 className="bold">You have insufficient XHT balance</h3>
                        <div className="bodyContentSmall">
                            You can go to your XHT wallet to charge your XHT balance
                            <span className="link" onClick={() => history.push('/credit')}>here </span>
                            or you can
                            <span className="link" onClick={() => setNextType('cryptoCurrency')}>go back </span>
                            and pick another payment option
                        </div>
                        {renderFooter()}
                    </div>
                );
            case 'enterPrise':
                return (
                    <div className="enterprise-form-wrapper">
                        <ModalContent
                            onSubmitEnterprise={submitEnterprise}
                        />
                    </div>
                );
            case 'fiat-application':
                return (
                    <FiatConfirmation
                        exchange={exchange}
                        onCancel={onCancel}
                        handleViewPlan={handleViewPlan}
                    />
                );
            default:
                return <div />
        }
    };

    const storePaymentMethod = async () => {
        try {
            if (invoice && invoice.id &&
                (paymentType === 'paypal' || paymentType === 'bank' || nextType === 'cryptoCurrency' || paymentType === 'stripe')) {
                setLoading(true);
                let method = '';
                switch (paymentType) {
                    case 'paypal':
                    case 'bank':
                    case 'stripe':
                        method = paymentType;
                        break;
                    case 'cryptoCurrency':
                        method = currency;
                        break;
                    default:
                        break;
                }
                const res = await requestStoreInvoice(invoice.id, { method });
                if (res.data) {
                    switch (paymentType) {
                        case 'paypal':
                            window.replace(res.data.meta.redirect_url, '_blank');
                            message.success('Redirecting to the paypal');
                            setInvoice(res.data);
                            setLoading(false);
                            onCancel(nextType);
                            break;
                        case 'stripe':
                            window.open(res.data.meta.redirect_url, '_blank');
                            message.success('Redirecting to the payment');
                            setInvoice(res.data);
                            setLoading(false);
                            onCancel(nextType);
                            break;
                        case 'bank':
                            setInvoice(res.data);
                            setNextType(paymentType);
                            break;
                        case 'cryptoCurrency':
                            if (res.data.method === 'xht' && res.data.is_paid) {
                                setNextType('xhtPayment');
                            } else if (res.data.method === 'xht' && !res.data.is_paid) {
                                setNextType('xhtInSufficient');
                            } else {
                                setNextType('cryptoPayment');
                            }
                            setInvoice({ ...invoice, method, meta: { ...invoice.meta, ...res.data } });
                            setCurrencyAddress(res.data);
                            break;
                        default:
                            break;
                    }
                    getInvoice();
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                }
            } else if (paymentType === 'cryptoCurrency' && !isErrorMsg.status && isVoucherAppliedPlugin) {
                setNextType(paymentType);
            } else if (isErrorMsg.status || !isVoucherAppliedPlugin) {
                message.error(isErrorMsg.errMsg)
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error(error.message);
            }
        }
    };

    const setCryptoPayTrue = async () => {
        try {
            if (invoice && invoice.id) {
                setLoading(true);
                const res = await requestStoreInvoice(invoice.id, {
                    method: invoice.method,
                    pay: true
                });
                if (res.data) {
                    getInvoice();
                    if (isAutomatedKYC) {
                        setNextType('kyc-payment-confirm');
                    } else {
                        setNextType('payment-confirm');
                    }
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                }
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error(error.message);
            }
        }
    };

    const getDetails = async () => {
        return await getActivate(pluginData.name);
    }

    const storePlanType = async () => {
        isLoading();
        updatePlanType(
            { id: exchange.id, plan: type, period: isMonthly ? 'month' : 'year' },
            setNextType('payment')
        );
        if (exchange.type !== 'DIY' && isBilling) {
            const pluginDetail = await getDetails();
            setInvoice(pluginDetail.data.data)
        }
    };

    const onClose = () => {
        updateTabParams();
        onCancel();
    }

    const handleBack = () => {
        switch (nextType) {
            case 'payment':
                if (exchange.type === 'DIY' && !isPendingPay) {
                    return setNextType('price');
                } else if (isAutomatedKYC || (invoice && invoice.description && invoice.description.includes("KYC")) || exchange.plan === 'boost' || isPendingPay) {
                    return onClose();
                } else {
                    return setNextType('price');
                }
            case 'bank':
                setNextType('payment')
                break;
            case 'cryptoCurrency':
                setNextType('payment')
                break;
            case 'cryptoPayment':
                setNextType('cryptoCurrency')
                setExchangeDetails(false)
                setCryptoPay('')
                break;
            case 'confirmation':
                setNextType('bank')
                break;
            default:
                break;
        }
    }

    const setBankIdentifierInvoice = async () => {
        try {
            const method = "bank";
            await requestStoreInvoice(invoice.id, { method, bank_identifier });
            setNextType('confirmation')
        } catch (error) {
            message.error(error.data.message)
        }
    }

    const handleNext = () => {
        switch (nextType) {
            case 'bank':
                setBankIdentifierInvoice();
                break;
            case 'cryptoCurrency':
                storePaymentMethod();
                break;
            case 'cryptoPayment':
                if (cryptoPayType === 'pay') {
                    setCryptoPayTrue();
                } else {
                    setNextType('payment-confirm');
                }
                break;
            case 'xhtPayment':
                setNextType('confirmation')
                break;
            default:
                break;
        }
    }

    const renderBtn = () => {
        switch (nextType) {
            case 'price':
                return (
                    <div className="d-flex">
                        <Button block type="primary" onClick={onCancel}>Back</Button>
                        <div className='btn-divider' />
                        <Button
                            block
                            type="primary"
                            onClick={storePlanType}
                            disabled={type === 'diy' && !isBilling}
                        >
                            Next
                        </Button>
                    </div>
                )
            case 'payment':
                return (
                    <div className="d-flex">
                        <Button block type="primary" onClick={handleBack}>Back</Button>
                        <div className='btn-divider' />
                        <Button block type="primary" disabled={loading} onClick={storePaymentMethod}>Next</Button>
                    </div>
                );
            case 'paypal':
                return null;
            case 'stripe':
                return null;
            case 'bank':
                return (
                    <div className="d-flex">
                        <Button block type="primary" onClick={handleBack}>Back</Button>
                        <div className='btn-divider' />
                        <Button block type="primary" onClick={handleNext}>
                            Proceed
                        </Button>
                    </div>
                );
            case 'cryptoCurrency':
                return (
                    <div className='d-flex'>
                        <Button block type="primary" onClick={handleBack}>Back</Button>
                        <div className='btn-divider' />
                        <Button block type="primary" disabled={loading} onClick={handleNext}>Next</Button>
                    </div>
                );
            case 'cryptoPayment':
                const balanceAvailable = balance[`${currency.toLowerCase()}_available`] || 0;
                const paymentAmount = currencyData.amount || 0;
                return (
                    <div className='d-flex'>
                        <Button block type="primary" onClick={handleBack}>
                            Back
                        </Button>
                        <div className='btn-divider' />
                        {cryptoPayType === "pay" ?
                            <Button
                                block type="primary"
                                disabled={cryptoPayType === 'pay' && (!balanceAvailable || balanceAvailable < paymentAmount || loading)}
                                onClick={handleNext}>
                                {cryptoPayType === 'pay' ? 'Proceed' : 'Yes, I have sent the crypto. Continue'}
                            </Button>
                            : <Button block type="primary" onClick={onClose}>
                                Done
                            </Button>
                        }
                    </div>
                );
            case 'xhtPayment':
                return (
                    <Button block type="primary" onClick={handleNext}>Confirm payment</Button>
                );
            case 'xhtInSufficient':
                return (
                    <Button block type="primary" onClick={() => history.push('/credit')}>Go to XHT Balance</Button>
                );
            case 'confirmation':
                return (
                    <div className="d-flex">
                        <Button block type="primary" onClick={handleBack}>Back</Button>
                        <div className="btn-divider" />
                        <Button block type="primary" onClick={onCancel}>Okay</Button>
                    </div>
                );
            case 'payment-confirm':
            case 'kyc-payment-confirm':
                return (
                    <Button block type="primary" onClick={onCancel}>Okay</Button>
                );
            default:
                return null;
        }
    };

    const getWidth = () => {
        if (nextType === 'price' && isBilling === false) {
            return '50rem';
        } else if (nextType === 'price') {
            return '58rem';
        } else if (nextType === 'cryptoPayment' || nextType === 'cryptoCurrency' || nextType === 'bank') {
            return '48rem';
        } else if (nextType === 'confirmation') {
            return '35rem';
        } else if (nextType === 'fiat-application') {
            return '49rem'
        } else if (nextType === 'payment-confirm') {
            return '28rem'
        } else if (nextType === 'kyc-payment-confirm') {
            return '30rem'
        } else {
            return '45rem';
        }
    };

    const renderModalContent = () => {
        switch (nextType) {
            case 'confirmation':
                return (
                    <div className="payment-container d-flex content-body">
                        <div className="confirmation-wrapper">
                            <div className="d-flex align-center">
                                <img
                                    src={EMAIL_PENDING_ICON}
                                    alt="mail-confirm-icon"
                                    className="send-mail-icon"
                                />
                                <div className="mail-title bold">Please check your email</div>
                            </div>
                            <div className="large-text">
                                <b>The payment details have been sent to your email.</b>
                                <div> Please check your email to complete your payment.</div>
                            </div>
                            <div className="btn-divider" />
                            <div className="warning-text d-flex my-1">
                                <ExclamationCircleFilled className="warning-icon" />
                                <div className='small-text'>
                                    <div>
                                        When sending your payment, make sure to include your reference number
                                    </div>
                                    sent to you via email.
                                </div>
                            </div>
                            <div className="btn-divider" />
                            <div className="button-container">
                                {renderBtn()}
                            </div>
                        </div>
                    </div>
                );
            case 'payment-confirm':
                return (
                    <div className="payment-container d-flex content-body">
                        <div className="confirmation-wrapper text-center">
                            <img
                                src={VERIFICATION_TICK_ICON}
                                alt="mail-confirm-icon"
                                className="send-mail-icon"
                            />
                            <h2 className="bold">Payment complete.</h2>
                            <div>
                                Your payment has been processed and
                            </div>
                            <div>
                                transaction details have been sent to your email.
                            </div>
                            <div className="button-container">
                                {renderBtn()}
                            </div>
                        </div>
                    </div>
                );
            case 'kyc-payment-confirm':
                return (
                    <div className="payment-container d-flex content-body">
                        <div className="confirmation-wrapper text-center">
                            <div className="verify-icon-wrapper">
                                <img
                                    src={KYC_PLUGIN_ICON}
                                    alt="kyc-confirm-icon"
                                    className="kyc-icon"
                                />
                                <img
                                    src={VERSION_TICK}
                                    alt="verification-icon"
                                    className="verify-icon"
                                />
                            </div>
                            {is_active
                                ?
                                <div className="bold">
                                    User verification charge was successful
                                </div>
                                :
                                <div className="bold">
                                    User verification activation and charge was successful
                                </div>
                            }
                            <div>
                                You are now able to automatically verify your users.
                            </div>
                            <div className="kyc-btn-wrapper">
                                {renderBtn()}
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="payment-container d-flex content-body">
                        <div className="data-content">
                            {renderBreadCrumb()}
                            {renderContent()}
                        </div>
                    </div>
                );
        }
    }

    return (
        <Modal
            width={getWidth()}
            className="payment-modal payment-modal-wrapper"
            zIndex={999}
            visible={isBilling || isOpen}
            onCancel={onClose}
            onOk={onOk}
            footer={null}
        >
            <Wrapper>
                {renderModalContent()}
            </Wrapper>
        </Modal>
    );
}

const mapStateToProps = (store) => {
    return {
        isBilling: store.plugin.isBilling,
        pluginData: store.plugin.pluginData,
        discountedPercentage: store.invoice.discountedPercentage,
        updatedPlugin: store.invoice.updatedPlugin,
        selectedpluginDetail: store.invoice.selectedpluginDetail,
    }
}

const mapDispatchToProps = (dispatch) => ({
    setDiscountedPercentage: bindActionCreators(BillingActions.setDiscountedPercentage, dispatch),
    setUpdatedPlugin: bindActionCreators(BillingActions.setUpdatedPlugin, dispatch),
    setSelectedpluginDetail: bindActionCreators(BillingActions.setSelectedpluginDetail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentModal);